export const POLES = [
  { id: 'pole-software', label: 'Software', gitlabGroup: 'poles/pole-software' },
  { id: 'pole-data-et-algo', label: 'Data & Algorithmes & IA', gitlabGroup: 'poles/pole-data-et-algo' },
  { id: 'pole-cloud-et-it', label: 'Cloud & IT', gitlabGroup: 'poles/pole-cloud-et-it' },
  { id: 'pole-devops-et-cybersec', label: 'DevOps & Cybersécurité', gitlabGroup: 'poles/pole-devops-et-cybersec' },
  { id: 'pole-iot-et-embarque', label: 'IoT & Embarqué', gitlabGroup: 'poles/pole-iot-et-embarque' },
  { id: 'pole-metier-et-usages', label: 'Métier & Usage', gitlabGroup: 'poles/pole-metier-et-usages' },
  { id: 'pole-management-et-projet', label: 'Management & Project', gitlabGroup: 'poles/pole-management-et-projet' },
  { id: 'pole-system-engineering', label: 'System Engineering', gitlabGroup: 'poles/p-le-ing-nierie-syst-me-et-logicielle' },
] as const;

export type PoleId = (typeof POLES)[number]['id'];

export const POLE_IDS = POLES.map(pole => pole.id) as [PoleId, ...PoleId[]];

/**
 * Value stored in (and filtered on) the search index's `poles` field. The
 * Lunr engine used in local dev splits filter values on any non-alphanumeric
 * character but indexes array elements whole, so `pole-software` never
 * matches itself; a purely alphanumeric value is left intact by both Lunr
 * and pg.
 */
export const toPoleSearchValue = (poleId: PoleId): string =>
  poleId.replace(/[^a-z0-9]/g, '');
